import $ from 'jquery';

$(function() {
  const $localPartners = $('.local-partners');
  const $postalCode = $('#postalCode');

  if ($localPartners.length > 0 && $postalCode.length > 0) {
    class PostalCodeAdvertiser {
      constructor($input) {
        this.$input = $input;
        this.postalCode;
        this.interval = null;
        this.invtervalTime = $localPartners.data("local-ads-settings");
        if (!this.invtervalTime || this.invtervalTime < 2) {
          this.invtervalTime = 2;
        } else if (this.invtervalTime > 30) {
          this.invtervalTime = 30;
        }

        this.$input.keyup((e) => {
          const $target = $(e.target);
          const newCode = $target.val();
          if (newCode.length != 5) {
            return;
          }
          if (newCode == this.postalCode) {
            return;
          }
          this.postalCode = newCode;
          this.renderAds();
          this.initializeRender();
        });
      }

      initializeRender() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        this.interval = setInterval(this.renderAds.bind(this), this.invtervalTime * 1000);
      }

      renderAds() {
        let data = {
          postalCode: this.postalCode
        };
        data[window.csrfTokenName] = window.csrfTokenValue;
        $.ajax({
          url: window.localPartnersAction,
          method: 'POST',
          data: data,
          success: function(response) {
            $localPartners.html(response);
          },
          error: function(response) {
            console.log('There was an error');
            console.log(response);
          }
        });
      }
    }

    const adHandler = new PostalCodeAdvertiser($postalCode);
    
    // If this browser supports geolocation
    // if ( "geolocation" in navigator ) {
    //
    //   // Get the position, and send it off via ajax to the server to get the ads we want
    //   navigator.geolocation.getCurrentPosition(function(position) {
    //
    //     const latlng = position.coords.latitude + ',' + position.coords.longitude;
    //     let data = {
    //       latlng: latlng
    //     };
    //
    //     data[window.csrfTokenName] = window.csrfTokenValue;
    //
    //     $.ajax({
    //       url: window.localPartnersAction,
    //       method: 'POST',
    //       data: data,
    //       success: function(response) {
    //         $localPartners.html(response);
    //       },
    //       error: function(response) {
    //         console.log('There was an error');
    //         console.log(response);
    //       }
    //     });
    //   });
    //
    //
    // } else { // If the browser doesn't handle geolocation
    //   console.log('geo location unsupported');
    // }
  }
});
